import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import LoaderProvider from './components/Loader/LoaderProvider';
import Loader from './components/Loader/Loader';

ReactDOM.render(
  <React.StrictMode>
    {/* <App /> */}
    <LoaderProvider>
      <Loader /> {/* Always mounted */}
      <App />
    </LoaderProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
